<template>
  <div class="home">
    <div class="typhoonNameLabel" tabindex="1">{{title}}
      <br><span style="font-size:15px;">等级:强热带风暴</span>
    </div>
    <div id="baiduMap" style="width: 100%; height: 100vh;"></div>
    <div class="top-bottom" style="width: 100%">
      <div style="position: absolute; width: 100%;">
        <marquee>{{ text }}</marquee>
      </div>
    </div>
    <div class="btn-bottom">
      <van-button round style="display: block" @click="onBtnClick('滚动直播')">滚动直播</van-button>
<!--      <van-button round style="display: block" @click="onBtnClick('天气实况')">天气实况</van-button>-->
<!--      <van-button round style="display: block" @click="onBtnClick('气象预警')">气象预警</van-button>-->
      <van-button round style="display: block" @click="onBtnClick('防御指南')">防御指南</van-button>
    </div>
  </div>
</template>

<script>

export default {
  name: "home",
  data () {
    return {
      map: undefined,
      title: '',
      text: ''
    }
  },
  mounted () {
    this.getData((title, lon, lat, points, pathList, lands) => {
      //初始化地图
      const map = new BMapGL.Map("baiduMap");
      this.map = map
      map.centerAndZoom(new BMapGL.Point(lon, lat), 7); //设置地图中心点和缩放级别
      map.enableScrollWheelZoom(true); //启用滚轮缩放
      // map.setMapStyleV2({
      //   styleId: '139d9575b812f8400b87cb27775aeb64'
      // });

      const pathPoints = []
      for (let i = 0; i < points.length; i++) {
        const lon = points[i].lng
        const lat = points[i].lat
        const info = points[i]
        pathPoints.push(new BMapGL.Point(lon, lat))
        this.createPoint(map, info, i === points.length - 1)
      }
      var polyline = new BMapGL.Polyline(pathPoints, {strokeColor:"black", strokeWeight: 1}); //定义折线对象
      map.addOverlay(polyline); //添加折线到地图中

      // const centerIcon = new BMapGL.Icon("https://hbrbapp.hubeidaily.net/h5/typhoon.gif", new BMapGL.Size(40, 40), {
      // });
      // // 创建标注对象并添加到地图
      // const centerMarker = new BMapGL.Marker(new BMapGL.Point(lon, lat), {icon: centerIcon})
      // map.addOverlay(centerMarker)

      const customOverlay = new BMapGL.CustomOverlay((feature) => {
        const element = document.createElement('img')
        element.src = 'https://hbrbapp.hubeidaily.net/h5/typhoon.gif'
        element.style.height = '40px'
        element.style.width = '40px'
        return element
      }, {
        point: new BMapGL.Point(lon, lat),
        opacity: 0.5,
        map: map,
        offsetY: -5,
        offsetX: 0,
      });
      map.addOverlay(customOverlay)

      const point = new BMapGL.Point(lon, lat)
      const label = new BMapGL.Label(title, {       // 创建文本标注
        position: point,                          // 设置标注的地理位置
        offset: new BMapGL.Size(20, -20)           // 设置标注的偏移量
      })
      label.setStyle({                              // 设置label的样式
        color: '#000',
        // fontSize: '30px',
        padding: '5px 10px',
        border: '1px solid black'
      })
      map.addOverlay(label)
      const color = ['blue', 'green', 'red', 'white', 'black']
      pathList.forEach((item, index) => {
        const currentPoints = []
        item.forecastpoints.forEach(point => {
          currentPoints.push(new BMapGL.Point(point.lng, point.lat))
          console.log(item)
          this.createPoint(map, point, false, true, item.tm)
        })
        const polyline = new BMapGL.Polyline(currentPoints, { strokeStyle: 'dashed', strokeColor: color[index], strokeWeight: 3}); //定义折线对象
        map.addOverlay(polyline) //添加折线到地图中
      })
      this.getBoundary()
      this.addLand(lands)
    })
  },
  methods: {
    onBtnClick (category) {
      const categoryDict = {
        '滚动直播': 'https://news.hubeidaily.net/hbrbsharenew/live_detail/4/2204/3084842/0',
        '天气实况': 'http://hubei.weather.com.cn/web/weatherFacts.html?data_type=pre24h&tabViewTop=0',
        '气象预警':'http://www.weather.com.cn/alarm/newalarmlist.shtml?areaId=10120',
        '防御指南': 'https://news.hubeidaily.net/hbrbsharenew/news_detail/5/3085172/0/0'
      }
      window.location.href = categoryDict[category]
    },
    addLand (lands) {
      lands.forEach(land => {
        const point = new BMapGL.Point(land.lng, land.lat)
        const label = new BMapGL.Label(land.info, {       // 创建文本标注
          position: point,                          // 设置标注的地理位置
          offset: new BMapGL.Size(10, -20),         // 设置标注的偏移量
          // MinZoom: 1
        })
        label.setStyle({                              // 设置label的样式
          color: '#000',
          fontSize: '10px',
          padding: '5px 10px',
          border: '1px solid black'
        })
        this.map.addOverlay(label)
        const centerIcon = new BMapGL.Icon("https://hbrbapp.hubeidaily.net/h5/flag.png", new BMapGL.Size(30, 30), {
        });
        // 创建标注对象并添加到地图
        const centerMarker = new BMapGL.Marker(point, {icon: centerIcon})
        this.map.addOverlay(centerMarker)
      })
    },
    getCircle (str) {
      if (str === undefined) {
        return '-'
      }
      const arr = str.split('|')
      return `${Math.min(...arr)}-${Math.max(...arr)}`
    },

    getBoundary() {
      this.addDistrict("湖北省")
    },
    addDistrict(districtName) {
      //使用计数器来控制加载过程
      let districtLoading = 0
      const blist = []
      districtLoading ++
      const bdary = new BMapGL.Boundary()
      bdary.get(districtName, (rs) => {
        const count = rs.boundaries.length
        for (let i = 0; i < count; i++) {
          blist.push({ points: rs.boundaries[i], name: districtName })
        }
        //加载完成区域点后计数器-1
        districtLoading--
        if (districtLoading === 0) {
          //全加载完成后画端点
          this.drawBoundary(blist)
        }
      });
    },
    drawBoundary(blist) {
      //包含所有区域的点数组
      let pointArray = [];
      //循环添加各闭合区域
      for (let i = 0; i < blist.length; i++) {
        //添加多边形层并显示
        const ply = new BMapGL.Polygon(blist[i].points, {
          strokeWeight: 1,   //边框宽度
          trokeColor: "#014F99",   //边框颜色
          fillColor: " #DDE4F0" //填充颜色
        }); //建立多边形覆盖物
        ply.name = blist[i].name
        // ply.addEventListener("click", click)
        this.map.addOverlay(ply)

        //将点增加到视野范围内
        const path = ply.getPath()
        pointArray = pointArray.concat(path)
      }
      console.log(pointArray)
      //限定显示区域(只显示特定区域，鼠标拖动松开后自动回到显示范围内)，需要引用api库
      // var boundply = new BMap.Polygon(pointArray);
      // BMapLib.AreaRestriction.setBounds(map, boundply.getBounds());
      // this.map.setViewport(pointArray);    //调整视野
    },
    getHTml (info) {
      const color = this.getColor(info.power)
      const liStyle = 'border-bottom: 1px #ddd solid; color: #a3a3a3; '
      const spanStyle = 'margin-left: 10px; color: #666;'
      let radius7Html = ''
      if (info.radius7) {
        radius7Html = `<li style="${liStyle}">七级半径<span style="${spanStyle}">${this.getCircle(info.radius7)}&nbsp;公里</span></li>`
      }
      let radius10Html = ''
      if (info.radius10) {
        radius10Html = `<li style="${liStyle}">十级半径<span style="${spanStyle}">${this.getCircle(info.radius10)}&nbsp;公里</span></li>`
      }
      let radius12Html = ''
      if (info.radius12) {
        radius12Html = `<li style="${liStyle}">十二级半径<span style="${spanStyle}">${this.getCircle(info.radius12)}&nbsp;公里</span>`
      }
      return '<div class="leaflet-popup-content">' +
          '<div>' +
          '<ul class="tfinfo" style="top: 20%; left: 50%;">' +
          `<li style="${liStyle}">` +
          `<li style="${liStyle}">中心位置` +
          `<span style="${spanStyle}">${info.lng}°&nbsp;/&nbsp;${info.lat}°</span></li>` +
          `<li style="${liStyle}">风速风力<span style="${spanStyle}">${_.get(info, 'speed', '-')}&nbsp;米/秒, <span style="font-weight:700;color:${color};">${_.get(info, 'power', '-')}级</span>` +
          '</span>' +
          '</li>' +
          `<li style="${liStyle}">中心气压<span style="${spanStyle}">${_.get(info, 'pressure', '-')}&nbsp;百帕</span>` +
          '</li>' +
          `<li style="${liStyle}">移速移向<span style="${spanStyle}">${_.get(info, 'movespeed', '-')}公里/小时，${_.get(info, 'movedirection', '')}</span>` +
          '</li>' +
          radius7Html +
          radius10Html +
          radius12Html +
          '</li>' +
          '</ul>' +
          '</div>' +
          '</div>'
    },
    createPoint (map, info, isShow = false, is_forcast=false, city='') {
      const title = `<h3 style="text-align: center; padding-top: 5px">${is_forcast ? `<span style="margin-right: 5px">【${city}预报】</span>` : ''}${this.$moment(info.time).format('MM月DD日HH时')}</h3>`
      const curPoint = new BMapGL.Point(info.lng, info.lat)
      const customOverlay = new BMapGL.CustomOverlay((feature) => {
        return this.createDOM(info.power, feature)
      }, {
        point: curPoint,
        opacity: 0.5,
        map: map,
        offsetY: -22,
        offsetX: 0,
      });
      const html = this.getHTml(info)
      const opts = {
        width : 250,     // 信息窗口宽度
        height: html.indexOf('七级半径') === -1 ? 120 : 200,     // 信息窗口高度
        title , // 信息窗口标题
        // enableMessage: true,//设置允许信息窗发送短息
        // message:""
      }
      const infoWindow = new BMapGL.InfoWindow(this.getHTml(info), opts);  // 创建信息窗口对象
      map.addOverlay(customOverlay);
      if (isShow) {
        map.openInfoWindow(infoWindow, curPoint)
      }
      customOverlay.addEventListener('click',  () => {
        map.openInfoWindow(infoWindow, curPoint)
      })
      customOverlay.addEventListener('mouseover', () => {
        map.openInfoWindow(infoWindow, curPoint)
      })
    },
    getColor (power) {
      let color
      if (power === ' ' || power === undefined) {
        color = 'white'
      } else if (power <= 7) {
        color = '#67C23A'
      } else if (power > 7 && power < 10) {
        color = '#409EFF'
      } else if (power < 12) {
        color = '#E6A23C'
      } else if (power < 15) {
        color = 'RGB(255, 105, 180)'
      } else {
        color = '#ea2424'
      }
      return color
    },
    createDOM (power, feature) {
      console.log(power)
      // const img = document.createElement('img');
      // img.style.height = '240px';
      // img.style.width = '80px';
      // img.src = 'https://bj.bcebos.com/v1/mapopen-pub-jsapigl/assets/images/fire.gif';
      // img.draggable = false;
      // return img;
      const color = this.getColor(power)
      console.log(power === '', color, 'xxxxx', power <= 7)
      const element = document.createElement('div')
      element.style.height = '8px'
      element.style.width = '8px'
      element.style.backgroundColor = color
      element.style.borderRadius = '50%'
      element.style.border = '1px solid black'
      return element
    },
    getData (callback) {
      this.$http.get(`https://hbrbapp.hubeidaily.net/h5/taifeng.json?v=${this.$moment().format('DDHHmm')}`).then(response => {
        const info = response.data
        // const lats = []
        // const lons = []
        // info.points.forEach(point => {
        //   lats.push(point.lat)
        //   lons.push(point.lng)
        // })
        this.title = `${info.tfid}${info.name}(${info.enname})`
        const title = `${info.name}(${this.$moment(info.endtime).format('MM月DD日HH时')})`
        const pathList = info.points[info.points.length - 1].forecast
        const nowInfo = info.points[info.points.length - 1]
        this.text = `2024年第11号强热带风暴${info.name}(${info.enname}) ${this.$moment(info.endtime).format('MM月DD日HH时')}，风速${_.get(nowInfo, 'speed', '-')}米/秒，移速${_.get(nowInfo, 'movespeed', '-')}公里/小时，东经${nowInfo.lng}°，北纬${nowInfo.lat}°，气压${_.get(nowInfo, 'pressure', '-')}百帕，近中心最大风力${_.get(nowInfo, 'power', '-')}级`
        // callback(info.centerlng, info.centerlat, lats, lons, pathList)
        callback(title, info.points[info.points.length - 1].lng, info.points[info.points.length - 1].lat, info.points, pathList, info.land)
      })
    }
  },
}
</script>

<style scoped lang="scss">
@import './index.scss';
.typhoonNameLabel {
  color: #ec2828;
  font: bold 40px "Helvetica Neue",Arial,Helvetica,sans-serif;
  letter-spacing: 3px;
  position: absolute;
  text-align: center;
  text-shadow: 1px 0 0 #fff,0 1px 0 #fff,-1px 0 0 #fff,0 -1px 0 #fff;
  top: 5px;
  white-space: nowrap;
  width: 100%;
  z-index: 2009;
  cursor: pointer;
}
@-webkit-keyframes marqueeAnimation  { 100%  {margin-left:-876px}}
.top-bottom {
  height: 60px;
  line-height: 60px;
  background-color: #fabb46;
  opacity: .8;
  color: #333;
  font-weight: 700;
  overflow: hidden;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1001;
  font-size: 28px;
}
.btn-bottom{
  position: fixed;
  z-index: 1000;
  right: 20px;
  bottom: 100px;
}
.btn-bottom button {
  margin-bottom: 15px;
  box-shadow: 18px 14px 28px -17px #224141;
}
</style>
